import { render, staticRenderFns } from "./BeltContainer.vue?vue&type=template&id=9cf36e48&scoped=true"
import script from "./BeltContainer.vue?vue&type=script&lang=js"
export * from "./BeltContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf36e48",
  null
  
)

export default component.exports